import * as Lucide from "lucide-react";

export const getIcon = (name) => Lucide[name] || Lucide.Database;
